module.exports = __webpack_public_path__ + "img/promo_desktop.837ce9bf.png";